import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EditFormInstance from './EditFormInstance';
import '../superadmin/DistrictsList.css';

const ViewForms = () => {
  const [formInstances, setFormInstances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFormInstance, setSelectedFormInstance] = useState(null);

  useEffect(() => {
    fetchFormInstances();
  }, []);

  const fetchFormInstances = async () => {
    try {
      const response = await axios.get('/api/form-instances/district');
      setFormInstances(response.data);
    } catch (error) {
      console.error('Failed to fetch form instances:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditForm = async (formInstance) => {
    setSelectedFormInstance(formInstance);
  };


  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="superadmins-list">
      <div className="page-header">
        <h2>Forms</h2>
      </div>

      {selectedFormInstance && (
        <EditFormInstance
          formInstance={selectedFormInstance}
          onClose={() => {
            setSelectedFormInstance(null);
            fetchFormInstances(); // Refresh list in case of changes
          }}
          onSave={() => {
            fetchFormInstances(); // Refresh list after save
          }}
        />
      )}

      <table className="data-table">
        <thead>
          <tr>
            <th>Form Name</th>
            <th>Description</th>
            <th>School Year</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {formInstances.length === 0 ? (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>No form instances available</td>
            </tr>
          ) : (
            formInstances.map(formInstance => (
              <tr key={formInstance.id}>
                <td>{formInstance.instance_name || formInstance.master_form_name}</td>
                <td>{formInstance.instance_description || '-'}</td>
                <td>{formInstance.school_year || '-'}</td>
                <td>{new Date(formInstance.created_at).toLocaleDateString()}</td>
                <td className="actions">
                  <button onClick={() => handleEditForm(formInstance)} className="btn-edit">Edit</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ViewForms;

